export const checkboxFields = [
  { name: "is_head_field", label: "Is Head Field" },
  { name: "is_item_field", label: "Is Item Field" },
  { name: "is_required", label: "Is Required" },
  { name: "is_new_form", label: "Is New Form" },
  { name: "is_internal_field", label: "Is Internal Field" },
  { name: "is_query", label: "Is Query" },
  { name: "is_tax", label: "Is Tax" },
  { name: "is_tax_percentage", label: "Is Tax Percentage" },
  { name: "is_read_only_on_edit", label: "Is Read Only On Edit" },
];

export const formFields = [
  {
    type: "text",
    name: "tran_code",
    label: "Transaction Code",
    required: true,
  },
  { type: "text", name: "field_name", label: "Field Name", required: true },
  { type: "text", name: "title", label: "Display Title", required: true },
  {
    type: "select",
    name: "data_type",
    label: "Data Type",
    options: [
      { value: "int", label: "Integer" },
      { value: "string", label: "String" },
      { value: "boolean", label: "Boolean" },
      { value: "date", label: "Date" },
      { value: "float", label: "Float" },
      { value: "decimal", label: "Decimal" },
      { value: "datetime", label: "DateTime" },
    ],
    required: true,
  },
  { type: "text", name: "field_length", label: "Field Length", required: true },
  {
    type: "select",
    name: "field_type",
    label: "Field Type",
    options: [
      { value: "DATE", label: "Date" },
      { value: "STRING", label: "String" },
      { value: "DROPDOWN", label: "Dropdown" },
      { value: "INTEGER", label: "Integer" },
      { value: "BOOLEAN", label: "Boolean" },
      { value: "TEXT", label: "Text" },
      { value: "FILE_UPLOAD", label: "File Upload" },
      { value: "DECIMAL", label: "Decimal" },
    ],
    required: true,
  },
  { type: "text", name: "db_query", label: "DB Query" },
  { type: "text", name: "options", label: "Options" },
  { type: "text", name: "table_name", label: "Table Name", required: true },
  { type: "text", name: "order_no", label: "Order No" },
  { type: "text", name: "new_form_id", label: "New Form Id" },
  {
    type: "select",
    name: "tax_type",
    label: "Tax Type",
    options: [
      { value: "percentage", label: "Percentage" },
      { value: "value", label: "Fixed Value" },
    ],
  },
  {
    type: "text",
    name: "tax_amount_calculation",
    label: "Tax Amount Calculation",
  },
  {
    type: "select",
    name: "status",
    label: "Status",
    options: [
      { value: "active", label: "Active" },
      { value: "in_active", label: "In Active" },
    ],
    required: true,
  },
  {
    type: "validation",
    name: "enter_validation",
    label: "Enter Validation",
  },
  {
    type: "validation",
    name: "leave_validation",
    label: "Leave Validation",
  },
];

export const defaultFormData = {
  tran_code: "",
  field_name: "",
  title: "",
  data_type: "",
  field_type: "",
  field_length: null,
  is_query: false,
  db_query: "",
  options: "",
  is_head_field: false,
  is_item_field: false,
  table_name: "",
  is_required: false,
  is_internal_field: false,
  is_new_form: false,
  new_form_id: null,
  order_no: null,
  is_tax: false,
  is_tax_percentage: false,
  tax_type: null,
  tax_amount_calculation: null,
  enter_validation: null,
  leave_validation: null,
};

export const editableFields = new Set([
  "title",
  "is_query",
  "db_query",
  "options",
  "is_required",
  "is_internal_field",
  "is_new_form",
  "new_form_id",
  "order_no",
  "is_tax",
  "is_tax_percentage",
  "tax_type",
  "tax_amount_calculation",
  "enter_validation",
  "leave_validation",
]);
